import { ClaimCardTypes } from '~components/SelectClaimStep/constants'

export const selectClaim = {
  setSelectedClaimType: ({ state }, payload) => {
    state.selectClaim.claimType = payload
  },

  setSelectedClaim: ({ state }, payload) => {
    state.selectClaim.claim = payload
  },

  setUsername: ({ state }, payload) => {
    state.selectClaim.username = payload
  },

  setVerificationTicket: ({ state }, payload) => {
    state.selectClaim.verificationTicket = payload
  },

  setVerificationTicketExpiresInSeconds: ({ state }, payload) => {
    state.selectClaim.verificationTicketExpiresInSeconds = payload
  },

  setSubmittedAt: ({ state }) => {
    state.selectClaim.submittedAt = Date.now()
  },

  resetVerificationTicketData: ({ state }) => {
    state.selectClaim.verificationTicket = ''
    state.selectClaim.verificationTicketExpiresInSeconds = 0
    state.selectClaim.submittedAt = 0
  },

  resetSelectClaimState: ({ state }) => {
    state.selectClaim.claimType = ClaimCardTypes.NONE
    state.selectClaim.claim = null
    state.selectClaim.username = ''
    state.selectClaim.verificationTicket = ''
    state.selectClaim.verificationTicketExpiresInSeconds = 0
    state.selectClaim.submittedAt = 0
  },
}
